import { Component, OnInit, Input, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import * as actions from '../../core/actions/expertise.actions';
import { Store } from '@ngrx/store';
import { ExpertiseService } from '../../shared/services/expertise.service';
import { Expertise } from '../../shared/models/expertise';
import { DialogService } from 'primeng/api';
import { ConsignmentFormComponent } from '../consignment-form/consignment-form.component';


@Component({
  selector: 'app-expertise-panel',
  templateUrl: './expertise-panel.component.html',
  styleUrls: ['./expertise-panel.component.scss'],
  providers: [DialogService]
})
export class ExpertisePanelComponent implements OnInit, OnChanges {

  public edit: boolean = false;
  public tarifedit: boolean = false;
  @Input() expertise: Expertise;
  @ViewChild('prestations',  {static: false}) prestations;

  constructor(private store: Store<any>, private expertiseService: ExpertiseService,
    public dialogService: DialogService
) { }

  ngOnInit() {
    if (this.expertise && this.expertise.id < 0 ) {
      this.edit = true;
    }
  }


  ngOnChanges(changes: SimpleChanges) {
  	  this.edit = this.edit && !(changes && changes.expertise && changes.expertise.currentValue && changes.expertise.currentValue.saved);
      this.tarifedit = this.tarifedit && !(changes && changes.expertise && changes.expertise.currentValue && changes.expertise.currentValue.saved);
  }
  addConsignment() {
    const ref = this.dialogService.open(ConsignmentFormComponent, {
      header: 'Nouveau montant consigné',
      width: '40%',
      styleClass: 'dynamicDialog',
  });
  ref.onClose.subscribe((car: any) => {
    if (car) {
        this.expertiseService.saveConsignment(this.expertise.id, car).subscribe(x => this.store.dispatch(
          new actions.SetConsignmentAction(x)
        ));
    }
});

  }

  editConsignment(c: any) {
    const ref = this.dialogService.open(ConsignmentFormComponent, {
      header: 'Modifier le montant consigné',
      width: '40%',
      styleClass: 'dynamicDialog',
      data: c
  });
  ref.onClose.subscribe((car: any) => {
    if (car) {
        this.expertiseService.saveConsignment(this.expertise.id, {...car, id: c.id}).subscribe(x => this.store.dispatch(
          new actions.SetConsignmentAction(x)
        ));
    }
});

  }
  deleteConsignemnt(id) {
    this.expertiseService.deleteConsignment(id).subscribe(x => this.store.dispatch(
      new actions.DeleteConsignmentAction(this.expertise.id, id)
      ));
  }
  getTotal(c: any[]) {
    return c.reduce((p, c) => p + parseFloat(c.amount), 0);
  }
  editExpertise() {
     this.edit = true;
  }
  editTarif() {
     this.tarifedit = true;
  }
  cancelEditTarif() {
    this.tarifedit = false;
  }
  cancel() {
  	this.edit = false;
  }

  save(expertise: any) {
  	this.store.dispatch(new actions.SaveExpertiseAction(expertise));
  }

  saveTarif(expertise: any) {
    this.store.dispatch(new actions.SaveExpertiseAction(expertise));
  }

  addPrestation() {
    this.prestations.addPrestation();
  }
}
